import React from "react";
import CoachCapacityPanel from "@/components/CoachCapacityPanel";

export default function CapacityPage({ mine = false }) {
  return (
    <div className="p-8 max-w-6xl" data-testid={mine ? "my-capacity-page" : "capacity-page"}>
      <h1 className="font-heading text-3xl font-light tracking-tight text-slate-900 mb-1">{mine ? "Meine Kapazität" : "Coach-Kapazität"}</h1>
      <p className="text-sm text-slate-500 mb-6">
        {mine ? "Deine Auslastung pro Woche und wann du wieder Platz für neue Kunden hast – nur du siehst diese Ansicht." : "Wer hat wann wieder Platz für einen neuen Kunden?"}
      </p>
      <CoachCapacityPanel mine={mine} />
    </div>
  );
}
